import { useCallback, useState } from "react";

const useCampaignFiltersState = () => {
  const [campaignFiltersNonce, setCampaignFiltersNonce] = useState(0);

  const handleCampaignFiltersSaved = useCallback(() => {
    setCampaignFiltersNonce((prev) => prev + 1);
  }, []);

  return { campaignFiltersNonce, handleCampaignFiltersSaved };
};

export default useCampaignFiltersState;
